import { z } from 'src/lib';
import { FilePutFields } from 'src/pages/sistema/api/file-fields';
import { OperacionCFFields } from './fields';
import { schemaStringObligatorio, schemaStringOpcional } from 'src/pages/sistema/types/types';
import { Validar } from '../../adl/types/dto';
import { OperacionCFTipo } from './enum';

const booleanTransform = (valor: any) => {
  if (typeof valor === 'boolean') return valor;
  if (valor == 1) return true;
  if (valor == 2) return false;
  return null;
};

const schemaBooleanCF = z.preprocess(booleanTransform, z.boolean({
  invalid_type_error: "Requerido"
}));

const schemaBooleanCFNullable = z.preprocess(booleanTransform, z.boolean().nullable().optional());

export const schemaOperacionCFInsert = z.object({
  [OperacionCFFields.CodPais]: z.number(),
  [OperacionCFFields.CodUnidadNegocio]: z.number(),
  [OperacionCFFields.CodSectorComercial]: z.number(),
  [OperacionCFFields.FechaSolicitud]: z.date(),

  [OperacionCFFields.RazonSocial]: schemaStringObligatorio,
  [OperacionCFFields.NumeroCuenta]: schemaStringOpcional,
  [OperacionCFFields.CodOperacionCFTipo]: z.number(),
  [OperacionCFFields.InformacionAdicionalEmpresa]: schemaStringOpcional,

  [OperacionCFFields.SuccessFee]: schemaStringOpcional,
  [OperacionCFFields.MontoMinimoSuccess]: schemaStringOpcional,
  [OperacionCFFields.CantMesesRetainer]: schemaStringOpcional,
  [OperacionCFFields.MontoRetainerMensual]: schemaStringOpcional,

  [OperacionCFFields.AcreditacionRetainerMensual]: schemaBooleanCF,
  [OperacionCFFields.Exclusividad]: schemaBooleanCF,

  [FilePutFields.File]: z.instanceof(File).optional().nullable(),
}).superRefine((data, ctx) => {
    
    // si es Cliente nro de cuenta es obligatorio
    if (data[OperacionCFFields.CodOperacionCFTipo] === OperacionCFTipo.Cliente) {
        if (!data[OperacionCFFields.NumeroCuenta]?.trim()) {
            Validar(ctx, OperacionCFFields.NumeroCuenta, "El número de cuenta es obligatorio");
        }
    }

});

export type OperacionCFInsert = z.infer<typeof schemaOperacionCFInsert>;